import {Injectable} from '@angular/core';
import {RegisterDataTableService} from '../../../core/services/register-data-table.service';
import {StorageService} from '../../../core/services/storage.service';
import {ITableColumn} from '../../../core/common/interfaces/table-column.interface';

@Injectable({
  providedIn: 'root'
})
export class TableServiceService extends RegisterDataTableService{

  constructor(
    storageService: StorageService
  ) {
    super(storageService);
  }

 private _columns: ITableColumn[] = [];
 override setColumns(columns: ITableColumn[]): void{
    this._columns = columns
 }

  override getColumns(): ITableColumn[] {
    return this._columns;
  }
}
